module.exports = __webpack_public_path__ + "media/images/icons/outlined/stock-2affb31ffdc75803f6cee117a9aaf7fd.svg";